import styles from '@jobcase/react_pattern_library/styles';
import rebrandStyles from '@jobcase/react_pattern_library/styles/rebrand';

const DEFAULT_CARD_HEIGHT = 304;
const CARD_MARGIN_BOTTOM = 16;
const COVER_PHOTO_HEIGHT = 200;
const COVER_PHOTO_WIDTH = 824;
const LOGO_HEIGHT = 80;
const LOGO_WIDTH = 80;
const COVER_PHOTO_HEIGHT_REBRAND = 230;
const COVER_PHOTO_WIDTH_REBRAND = 952;
const LOGO_HEIGHT_REBRAND = 120;
const LOGO_WIDTH_REBRAND = 120;

export const TIME_DURATIONS = [{
  title: '15 min',
  key: 15,
  selected: false,
  hovered: false,
  disabled: false,
}, {
  title: '30 min',
  key: 30,
  selected: false,
  hovered: false,
  disabled: false,
}, {
  title: '1 hour',
  key: 60,
  selected: false,
  hovered: false,
  disabled: false,
}, {
  title: 'None',
  key: 0,
  selected: false,
  hovered: false,
  disabled: false,
}];

export const TIME_DURATIONS_STRINGS = {
  0: 'None',
  15: '15 Minutes',
  30: '30 Minutes',
  60: '60 Minutes',
};

export const TIME_ZONE = [{
  title: 'Eastern Time',
  key: 'America/New_York',
  selected: false,
  hovered: false,
}, {
  title: 'Central Time',
  key: 'America/Chicago',
  selected: false,
  hovered: false,
}, {
  title: 'Mountain Time',
  key: 'America/Denver',
  selected: false,
  hovered: false,
}, {
  title: 'Pacific Time',
  key: 'America/Los_Angeles',
  selected: false,
  hovered: false,
}, {
  title: 'Hawaii-Aleutian Time',
  key: 'Pacific/Honolulu',
  selected: false,
  hovered: false,
}, {
  title: 'Alaska Time',
  key: 'America/Anchorage',
  selected: false,
  hovered: false,
}, {
  title: 'Atlantic Time',
  key: 'America/Puerto_Rico',
  selected: false,
  hovered: false,
}];

export const INITIAL_HIRING_EVENT_STATE = {
  title: '',
  marketing_title: '',
  employer_alias: '',
  linked_hub: '',
  virtual_event_link: '',
  event_type: '',
  date: '',
  time_zone_name: '',
  time_duration: 0,
  start_time: '',
  end_time: '',
  venue_name: '',
  venue_address1: '',
  venue_address2: '',
  venue_city: '',
  venue_subdivision: '',
  venue_postal_code: '',
  logo_photo: '',
  cover_photo: '',
  billing_reference_number: '',
  collect_resumes: false,
  resume_required: false,
  event_latitude: '',
  event_longitude: '',
};

export const OPTIONAL = [
  'employer_alias',
  'linked_hub',
  'cover_photo',
  'logo_photo',
  'billing_reference_number',
  'venue_address2',
  'collect_resumes',
  'resume_required',
  'virtual_event_link',
];

export const INITIAL_EVENT_ERRORS_STATE = {
  title: false,
  marketing_title: false,
  event_type: false,
  virtual_event_link: false,
  date: false,
  time_zone_name: false,
  time_duration: false,
  start_time: false,
  end_time: false,
  time_incorrect: false,
  venue_name: false,
  venue_address1: false,
  venue_city: false,
  venue_subdivision: false,
  venue_postal_code: false,
  valid_zip_code: false,
  logo_photo: false,
};

const TimeSlots = {
  '00:00': '12:00 AM',
  '00:30': '12:30 AM',
  '01:00': '1:00 AM',
  '01:30': '1:30 AM',
  '02:00': '2:00 AM',
  '02:30': '2:30 AM',
  '03:00': '3:00 AM',
  '03:30': '3:30 AM',
  '04:00': '4:00 AM',
  '04:30': '4:30 AM',
  '05:00': '5:00 AM',
  '05:30': '5:30 AM',
  '06:00': '6:00 AM',
  '06:30': '6:30 AM',
  '07:00': '7:00 AM',
  '07:30': '7:30 AM',
  '08:00': '8:00 AM',
  '08:30': '8:30 AM',
  '09:00': '9:00 AM',
  '09:30': '9:30 AM',
  '10:00': '10:00 AM',
  '10:30': '10:30 AM',
  '11:00': '11:00 AM',
  '11:30': '11:30 AM',
  '12:00': '12:00 PM',
  '12:30': '12:30 PM',
  '13:00': '1:00 PM',
  '13:30': '1:30 PM',
  '14:00': '2:00 PM',
  '14:30': '2:30 PM',
  '15:00': '3:00 PM',
  '15:30': '3:30 PM',
  '16:00': '4:00 PM',
  '16:30': '4:30 PM',
  '17:00': '5:00 PM',
  '17:30': '5:30 PM',
  '18:00': '6:00 PM',
  '18:30': '6:30 PM',
  '19:00': '7:00 PM',
  '19:30': '7:30 PM',
  '20:00': '8:00 PM',
  '20:30': '8:30 PM',
  '21:00': '9:00 PM',
  '21:30': '9:30 PM',
  '22:00': '10:00 PM',
  '22:30': '10:30 PM',
  '23:00': '11:00 PM',
  '23:30': '11:30 PM',
  '23:59': '11:59 PM',
};

const HIRING_EVENT_TABS = {
  EVENT_DETAILS: 'event_details',
  JOB_DETAILS: 'job_details',
  OTHER_DETAILS: 'other_details',
  REGISTRATION: 'registration',
  REGISTRANTS: 'registrants',
  ADMIN: 'admin',
};

const HIRING_EVENT_TABS_DESKTOP_TITLES = {
  event_details: 'Event Details',
  job_details: 'Job Details',
  other_details: 'Other Details',
};

const HIRING_EVENT_TABS_MOBILE_TITLES = {
  event_details: 'Event',
  job_details: 'Jobs',
  other_details: 'Other Details',
  registrants: 'Registrants',
};

const HIRING_EVENT_TABS_TITLES_REBRAND = {
  event_details: 'Overview',
  job_details: 'Jobs',
  other_details: 'Details',
  registrants: 'Registrants',
  registration: 'Registration',
};

const CREATE_HIRING_EVENTS_STEPS = {
  EVENT_DETAIL: 1,
  JOBS_DETAIL: 2,
  OTHER_DETAIL: 3,
  REGISTRATION_DETAIL: 4,
  ADMIN_SETTINGS: 5,
};

const HIRING_EVENTS_IMAGES_TYPES = {
  COMPANY_LOGO: 'COMPANY_LOGO',
  COMPANY_BANNER: 'COMPANY_BANNER',
};

const HIRING_EVENT_STATUS_LIST = {
  DRAFT: 'Draft',
  ENDED: 'Ended',
  APPROVAL_PENDING: 'Approval Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  CANCELED: 'Canceled',
};

const STATUS_COLORS = {
  APPROVAL_PENDING: { bgColor: styles.color.hiringEventApprovalPending, textColor: styles.color.blackBackgroundColor },
  APPROVED: { bgColor: styles.color.hiringEventApproved, textColor: styles.color.blackBackgroundColor },
  CANCELED: { bgColor: styles.color.hiringEventCanceled, textColor: styles.color.whiteText },
  DRAFT: { bgColor: styles.color.hiringEventDraft, textColor: styles.color.blackBackgroundColor },
  ENDED: { bgColor: styles.color.hiringEventEnded, textColor: styles.color.titleTextColor },
  REJECTED: { bgColor: styles.color.hiringEventRejected, textColor: styles.color.whiteText },
};

const EVENT_STATUS_CONSTANTS = {
  APPROVAL_PENDING: 'APPROVAL_PENDING',
  APPROVED: 'APPROVED',
  CANCELED: 'CANCELED',
  CHANGES_PENDING: 'CHANGES_PENDING',
  CHANGES_REJECTED: 'CHANGES_REJECTED',
  DRAFT: 'DRAFT',
  ENDED: 'ENDED',
  REJECTED: 'REJECTED',
};

const REQUIRED_CARD_KEYS = [
  'BENEFITS',
  'WHY_ATTEND',
  'SHIFT_INFO',
];

const REQUIRED_CARD_KEYS_REBRAND = [
  'WHY_ATTEND',
  'BENEFITS',
  'SHIFT_INFO',
];

const SUBMIT_EVENT_PROMPT = {
  headerText: 'Submit This Event?',
  bodyText: 'Are you sure you want to submit this event?',
  primaryButtonText: 'Submit Event',
  className: 'submit-confirmation-modal',
};

const DELETE_EVENT_PROMPT = {
  headerText: 'Delete This Event?',
  bodyText: 'This will permanently delete all information associated with the event.',
  primaryButtonText: 'Delete Event',
  className: 'delete-confirmation-modal',
};

const APPROVE_EVENT_PROMPT = {
  headerText: 'Approve This Event?',
  bodyText: 'Are you sure you want to approve this event?',
  primaryButtonText: 'Approve Event',
  className: 'submit-confirmation-modal',
};

const DENY_EVENT_PROMPT = {
  headerText: 'Reject This Event?',
  bodyText: 'Are you sure you want to reject this event?',
  primaryButtonText: 'Reject Event',
  className: 'submit-confirmation-modal',
};

const CANCEL_EVENT_PROMPT = {
  headerText: 'Cancel This Event?',
  bodyText: 'Are you sure you want to cancel this event?',
  primaryButtonText: 'Cancel Event',
  className: 'submit-confirmation-modal',
};

const RE_SUBMIT_EVENT_PROMPT = {
  headerText: 'Re-Submit This Event?',
  bodyText: 'Are you sure you want to re-submit this event?',
  primaryButtonText: 'Re-Submit Event',
  className: 'submit-confirmation-modal',
};

const DOWNLOAD_REGISTRATION_PROMPT = {
  headerText: 'Download Registrations',
  primaryButtonText: 'Download Registrations',
  showSecondaryButton: false,
  className: 'download-confirmation-modal',
};

const DOWNLOAD_REGISTRATION_PROMPT_REBRAND = {
  headerText: 'Download registrations',
  primaryButtonText: 'Download registrations',
  showSecondaryButton: false,
  className: 'download-confirmation-modal',
};

const EVENT_DETAIL_FIELD_REFS = {
  title: 'title',
  marketing_title: 'marketing_title',
  linked_hub: 'linked_hub',
  virtual_event_link: 'virtual_event_link',
  event_type: 'event_type',
  date: 'date',
  time_zone_name: 'time_zone_name',
  time_duration: 'time_duration',
  start_time: 'start_time',
  end_time: 'end_time',
  venue_name: 'venue_name',
  venue_address1: 'venue_address1',
  venue_city: 'venue_city',
  venue_subdivision: 'venue_subdivision',
  venue_postal_code: 'venue_postal_code',
  cover_photo: 'cover_photo',
  employer_alias: 'employer_alias',
  billing_reference_number: 'billing_reference_number',
  venue_address2: 'venue_address2',
};

const ADMIN_DETAIL_FIELD_REFS = {
  campaign_id: 'campaign_id',
  group_id: 'group_id',
  virtual_event_link: 'virtual_event_link',
  max_sends: 'max_sends',
  max_distance: 'max_distance',
  tcpa: 'tcpa',
  cpc: 'cpc',
  email_lead_time: 'email_lead_time',
  sms_lead_time: 'sms_lead_time',
  registrant_count_overage_percentage: 'registrant_count_overage_percentage',
  promotion_start_date: 'promotion_start_date',
  min_expected_registrants: 'min_expected_registrants',
  max_expected_registrants: 'max_expected_registrants',
  facebook_daily_budget: 'facebook_daily_budget',
  purchase_order: 'purchase_order',
  salesforce_deal_contract_id: 'salesforce_deal_contract_id',
  salesforce_deal_line_item_id: 'salesforce_deal_line_item_id',
  billing_reference_number: 'billing_reference_number',
  external_vendor_id: 'external_vendor_id',
};

const EVENT_JOB_DETAILS_INITIAL_STATE = {
  job_title: '',
  salary: '',
  employment_type: '',
  job_url: '',
  location: '',
  site_id: '',
};

const EVENT_JOB_DETAILS_OPTIONAL_FIELDS = [
  'salary',
  'job_url',
  'site_id',
];

const EVENT_JOB_DETAILS_INITIAL_ERRORS_STATE = {
  job_title: false,
  salary: false,
  employment_type: false,
  job_url: false,
  location: false,
  site_id: false,
};

const EVENT_JOB_DETAILS_EMPLOYMENT_TYPES = {
  CONTRACT: 'Contract',
  FULL_TIME: 'Full-Time',
  GIG: 'Gig',
  INTERNSHIP: 'Internship',
  ONE_TIME: 'One-Time',
  PART_TIME: 'Part-Time',
  SEASONAL: 'Seasonal',
  TEMPORARY: 'Temporary',
  VOLUNTEER: 'Volunteer',
  WORK_FROM_HOME: 'Work from Home',
};

const EVENT_JOB_SALARY_REGEX = /^(\$){0,1}(\d+(\.\d+){0,1})$/;

const EVENT_OTHER_DETAILS_INITIAL_STATE = {
  WHY_ATTEND: {
    heading: 'Why Attend',
    displayTitle: 'Why you should attend',
    body: '',
    exampleText: 'For example: Work from home opportunities, Flexible schedule, Sign on bonus',
  },
  BENEFITS: {
    heading: 'Benefits',
    displayTitle: 'Pay and benefits',
    body: '',
    exampleText: 'For example: Hourly pay starts at $15 per hour or health and dental benefits',
  },
  SHIFT_INFO: {
    heading: 'Shift Info',
    displayTitle: 'Shift information',
    body: '',
    exampleText: 'For example: Hiring Drivers for night shifts only from 1am-6am',
  },
};

const EVENT_OTHER_DETAILS_INITIAL_STATE_REBRAND = {
  WHY_ATTEND: {
    heading: 'Why attend',
    displayTitle: 'Why you should attend',
    body: '',
    exampleText: 'For example: Work from home opportunities, Flexible schedule, Sign on bonus',
  },
  BENEFITS: {
    heading: 'Benefits',
    displayTitle: 'Pay and benefits',
    body: '',
    exampleText: 'For example: Hourly pay starts at $15 per hour or health and dental benefits',
  },
  SHIFT_INFO: {
    heading: 'Shift info',
    displayTitle: 'Shift information',
    body: '',
    exampleText: 'For example: Hiring Drivers for night shifts only from 1am-6am',
  },
};

const OTHER_DETAIL_HELP_TEXT = {
  BENEFITS: 'For example: Hourly pay starts at $15 per hour or health and dental benefits',
  SHIFT_INFO: 'For example: Hiring Drivers for night shifts only from 1am-6am',
  WHY_ATTEND: 'For example: Hourly pay starts at $15 per hour or health and dental benefits',
};

const OTHER_DETAIL_HEADINGS = {
  BENEFITS: 'Benefits',
  SHIFT_INFO: 'Shift info',
  WHY_ATTEND: 'Why attend',
};

const CARD_TITLES = {
  ADDITIONAL_INFO: 'Additional info',
  COMPANY_INFO: 'Company info',
  DAY_OF_INTERVIEW: 'Day of interview',
  DIRECTIONS_TO_VENUE: 'Directions to venue',
  POST_EVENT_QUESTION: 'Post event question',
  PRE_EVENT_QUESTION: 'Pre event question',
  REQUIREMENTS: 'Requirements',
  WHAT_IS_AN_EVENT: 'What is an event',
  WHAT_TO_BRING: 'What to bring',
  WHAT_TO_EXPECT: 'What to expect',
  WHAT_TO_WEAR: 'What to wear',
  WHY_ATTEND: 'Why you should attend',
  BENEFITS: 'Pay and benefits',
  SHIFT_INFO: 'Shift information',
};

const EVENT_MORE_DETAILS_PILLS = [
  'What to expect',
  'Company info',
  'Additional info',
  'What is an event',
  'Requirements',
  'What to bring',
  'What to wear',
  'Directions to venue',
  'Day of interview',
];

const EVENT_PROMPT_MODAL_INITIAL_STATE = {
  type: '',
  headerText: '',
  bodyText: '',
  primaryButtonText: '',
  primaryOnClick: null,
  showSecondaryButton: false,
  secondaryButtonText: '',
  secondaryOnClick: null,
  onClose: null,
};

const SUCCESS_EVENT_PROMPT = {
  type: 'SUCCESS',
  headerText: 'Your Draft Has Been Saved!',
  bodyText: 'Your event draft has been saved and can be submitted for approval through your dashboard.',
  primaryButtonText: 'Close',
};

const SUCCESS_EVENT_PROMPT_REBRAND = {
  type: 'SUCCESS',
  headerText: 'Your draft has been saved.',
  bodyText: 'Your event draft has been saved and can be submitted for approval through your dashboard.',
  primaryButtonText: 'Close',
};

const EDIT_EVENT_PROMPT = {
  type: 'EDIT',
  headerText: 'Exit Without Saving Changes?',
  bodyText: 'Your updates will be discarded if you don\'t save.',
  primaryButtonText: 'Exit Without Saving',
  showSecondaryButton: true,
  secondaryButtonText: 'Keep Editing',
};

const EDIT_EVENT_PROMPT_REBRAND = {
  type: 'EDIT',
  headerText: 'Exit without saving changes?',
  bodyText: 'Your updates will be discarded if you don\'t save.',
  primaryButtonText: 'Exit without saving',
  showSecondaryButton: true,
  secondaryButtonText: 'Keep editing',
};

const DELETE_DETAIL_PROMPT = {
  type: 'DELETE',
  headerText: 'Delete Detail?',
  bodyText: 'Are you sure you want to delete this detail and all associated information?',
  primaryButtonText: 'Delete',
  showSecondaryButton: true,
  secondaryButtonText: 'Keep Editing',
};

const DELETE_DETAIL_PROMPT_REBRAND = {
  type: 'DELETE',
  headerText: 'Delete detail?',
  bodyText: 'Are you sure you want to delete this detail and all associated information?',
  primaryButtonText: 'Delete',
  showSecondaryButton: true,
  secondaryButtonText: 'Keep editing',
};

const TEXT_EDITOR_TABS = {
  WRITE: 'write',
  PREVIEW: 'preview',
};

const EVENT_TYPE = [
  {
    key: 'IN_PERSON',
    title: 'In Person',
  },
  {
    key: 'ONLINE_CHAT',
    title: 'Online Chat',
  },
  {
    key: 'PHONE_INTERVIEW',
    title: 'Phone Interview',
  },
  {
    key: 'VIRTUAL',
    title: 'Virtual',
  },
  {
    key: 'VIDEO_CHAT',
    title: 'Video Chat',
  },
];

const FACEBOOK_CHANNELS = [
  {
    key: 'NONE',
    title: 'None',
  },
  {
    key: 'ALL',
    title: 'All',
  },
  {
    key: 'DIRECT',
    title: 'Direct',
  },
  {
    key: 'LANDING_PAGE',
    title: 'Landing Page',
  },
  {
    key: 'SPECIAL',
    title: 'Special',
  },
];

const VENDOR_NAMES = {
  None: 'NONE',
  Brazen: 'BRAZEN',
  Typeform: 'TYPEFORM',
  Employer: 'EMPLOYER',
};

const FACEBOOK_CHANNELS_VALUES = {
  NONE: 'None',
  ALL: 'All',
  DIRECT: 'Direct',
  LANDING_PAGE: 'Landing Page',
  SPECIAL: 'Special',
};

const VALID_EVENT_TYPES = [
  'IN_PERSON',
  'ONLINE_CHAT',
  'PHONE_INTERVIEW',
  'VIDEO_CHAT',
  'VIRTUAL',
];

const VALID_REGISTRANTS_EVENT_TYPES = [
  'IN_PERSON',
  'VIRTUAL',
  'PHONE_INTERVIEW',
];

const TIME_ZONES_ABBRS = {
  'America/Anchorage': 'AKT',
  'America/Chicago': 'CT',
  'America/Denver': 'MT',
  'America/Juneau': 'AKT',
  'America/Los_Angeles': 'PT',
  'America/New_York': 'ET',
  'America/Puerto_Rico': 'AT',
  'Pacific/Honolulu': 'HT',
};

const MARKETING_TITLE_LIMIT = 255;

const EVENT_TYPE_CONSTANTS = {
  IN_PERSON: 'IN_PERSON',
  VIRTUAL: 'VIRTUAL',
  VIDEO_CHAT: 'VIDEO_CHAT',
  PHONE_INTERVIEW: 'PHONE_INTERVIEW',
  ONLINE_CHAT: 'ONLINE_CHAT',
};

const EVENT_TYPES_WITH_VIRTUAL_EVENT_LINK = [
  EVENT_TYPE_CONSTANTS.VIRTUAL,
  EVENT_TYPE_CONSTANTS.VIDEO_CHAT,
  EVENT_TYPE_CONSTANTS.PHONE_INTERVIEW,
  EVENT_TYPE_CONSTANTS.ONLINE_CHAT,
];

const EVENT_TYPES_WITH_REGISTRATION_TAB = [
  EVENT_TYPE_CONSTANTS.IN_PERSON,
  EVENT_TYPE_CONSTANTS.PHONE_INTERVIEW,
  EVENT_TYPE_CONSTANTS.ONLINE_CHAT,
  EVENT_TYPE_CONSTANTS.VIRTUAL,
];

const SORT_OPTIONS = [
  {
    label: 'Created: Newest',
    value: 'created_at_sortable&true',
  },
  {
    label: 'Created: Oldest',
    value: 'created_at_sortable&false',
  },
  {
    label: 'Event Date: Last',
    value: 'start_dates&true',
  },
  {
    label: 'Event Date: First',
    value: 'start_dates&false',
  },
  {
    label: 'Last Updated: Newest',
    value: 'updated_at_sortable&true',
  },
  {
    label: 'Last Updated: Oldest',
    value: 'updated_at_sortable&false',
  },
  {
    label: 'Location: A-Z',
    value: 'venue_subdivision.keyword&false',
  },
  {
    label: 'Location: Z-A',
    value: 'venue_subdivision.keyword&true',
  },
];

const SORT_OPTIONS_REBRAND = [
  {
    label: 'Newest created',
    value: 'created_at_sortable&true',
  },
  {
    label: 'Oldest created',
    value: 'created_at_sortable&false',
  },
  {
    label: 'Newest event date',
    value: 'start_dates&true',
  },
  {
    label: 'Oldest event date',
    value: 'start_dates&false',
  },
  {
    label: 'Newest updated',
    value: 'updated_at_sortable&true',
  },
  {
    label: 'Oldest updated',
    value: 'updated_at_sortable&false',
  },
  {
    label: 'Location A-Z',
    value: 'venue_subdivision.keyword&false',
  },
  {
    label: 'Location Z-A',
    value: 'venue_subdivision.keyword&true',
  },
];

const REGISTRANTS_SORT_OPTIONS = [
  {
    label: 'Registration: Newest',
    value: 'createdAt&true',
  },
  {
    label: 'Registration: Oldest',
    value: 'createdAt&false',
  },
  {
    label: 'First Name: A-Z',
    value: 'firstName&false',
  },
  {
    label: 'First Name: Z-A',
    value: 'firstName&true',
  },
  {
    label: 'Last Name: A-Z',
    value: 'lastName&false',
  },
  {
    label: 'Last Name: Z-A',
    value: 'lastName&true',
  },
];

const WARNING_BEFORE_EDIT_BODY_TEXT = 'Editing event details will take this event offline and back to draft status.'
+ '<span> You must resubmit this event for approval after you save your changes.</span>';

const WARNING_BEFORE_SAVE_BODY_TEXT = 'Saving your changes will take this event offline and back to draft status.'
+ '<span> You must resubmit this event for approval after you save your edits.</span>';

export const HIRING_EVENT_IMAGE_TYPE = {
  COMPANY_BANNER: 'COMPANY_BANNER',
  COMPANY_LOGO: 'COMPANY_LOGO',
};

const HIRING_EVENTS_STEPS_TITLE = {
  EVENT: 'Basic info',
  JOBS: 'Jobs',
  DETAILS: 'Details',
  ADMIN: 'Admin',
};

const HIRING_EVENTS_STEPS_TITLE_REBRAND = {
  EVENT: 'Information',
  JOBS: 'Jobs',
  DETAILS: 'Details',
  REGISTRATION: 'Registration',
  ADMIN: 'Admin',
};

const INITIAL_EVENT_STATE = {
  campaign_id: '',
  group_id: '',
  virtual_event_link: '',
  application_event: true,
  external_vendor: '',
  external_vendor_id: '',
  billing_reference_number: '',
  event_type: '',
};

const INITIAL_PROMOTION_DETAILS = {
  purchase_order: '',
  is_promoted: false,
  is_channel_overlays: false,
  is_custom_promotion: false,
  is_channel_call_center: false,
  max_sends: '',
  max_distance: '',
  tcpa: '',
  cpc: '',
  email_lead_time: '4',
  sms_lead_time: '3',
  other_paid_channels: '',
  facebook_channel: 'NONE',
  salesforce_deal_contract_id: '',
  salesforce_deal_line_item_id: '',
  budget: '',
  min_expected_registrants: '',
  max_expected_registrants: '',
  facebook_daily_budget: '',
  registrant_count_overage_percentage: '10',
  promotion_start_date: '',
};

const INITIAL_ERROR_STATE = {
  campaign_id: false,
  group_id: false,
  virtual_event_link: false,
  max_sends: false,
  max_distance: false,
  tcpa: false,
  cpc: false,
  email_lead_time: false,
  sms_lead_time: false,
  promotion_start_date: false,
  min_expected_registrants: false,
  max_expected_registrants: false,
  facebook_daily_budget: false,
  purchase_order: false,
  salesforce_deal_contract_id: false,
  salesforce_deal_line_item_id: false,
  billing_reference_number: false,
  external_vendor_id: false,
};

const EVENT_TAG_BG_COLOR_REBRAND = {
  APPROVAL_PENDING: rebrandStyles.color.mediumYellowColor,
  APPROVED: rebrandStyles.color.lightSuccessColor,
  CANCELED: rebrandStyles.color.commentBoxGrayColor,
  DRAFT: rebrandStyles.color.lightBlueColor,
  ENDED: rebrandStyles.color.commentBoxGrayColor,
  REJECTED: rebrandStyles.color.lightErrorColor,
};

const OPTIONAL_CARD_KEYS = [
  'COMPANY_INFO',
  'DAY_OF_INTERVIEW',
  'DIRECTIONS_TO_VENUE',
  'WHAT_TO_BRING',
  'WHAT_TO_WEAR',
  'WHAT_TO_EXPECT',
  'ADDITIONAL_INFO',
  'WHAT_IS_AN_EVENT',
  'REQUIREMENTS',
];

const EVENT_TYPE_TEXT = {
  IN_PERSON: 'In Person',
  ONLINE_CHAT: 'Online Chat',
  PHONE_INTERVIEW: 'Phone Interview',
  VIDEO_CHAT: 'Video Chat',
  VIRTUAL: 'Virtual',
};

const STATES = {
  None: 'None',
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  'District of Columbia': 'DC',
  Florida: 'FL',
  Georgia: 'GA',
  Guam: 'GU',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Puerto Rico': 'PR',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  'Virgin Islands': 'VI',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
};

const DEFAULT_SORT_OPTIONS = {
  sort_field: 'created_at_sortable',
  desc_sort: 'true',
};

export const EVENT_DETAIL_ERROR_MESSAGES = {
  title: {
    required: 'You must enter event title',
  },
  marketing_title: {
    required: 'You must enter a marketing headline title',
  },
  employer_alias: {
  },
  virtual_event_link: {
    required: 'You must enter a valid URL',
  },
  event_type: {
    required: 'You must choose event type',
  },
  date: {
    required: 'You must choose event date',
    inValid: 'Invalid date',
  },
  time_zone_name: {
    required: 'You must choose a time zone',
  },
  time_slots: {
    required: 'You must choose a start and end time',
    inValid: 'You must choose a start time before end time',
  },
  venue_name: {
    required: 'You must enter venue name',
  },
  venue_address1: {
    required: 'You must enter an address',
    zipCode: 'You must enter a zip code',
  },
  venue_postal_code: {
    required: 'You must enter zip code',
    notFound: 'Zip code not found',
    selectFromList: 'Zip code must be selected from search dropdown',
  },
};

export const EVENT_DETAIL_VALIDATE_FIELDS_FOR_VALID_CHARS = [
  'title',
  'marketing_title',
  'employer_alias',
  'virtual_event_link',
  'venue_name',
  'venue_address2',
  'billing_reference_number',
];

export const EVENT_DETAIL_FIELDS_TO_VALIDATE_WITH_MARKDOWN_REGEX = new Set(['marketing_title']);

export const JOB_DETAIL_ERROR_MESSAGES = {
  job_title: {
    required: 'You must enter a job title',
  },
  job_url: {
    invalid: 'Enter a valid link starting with http:// or https://',
  },
  salary: {
    required: 'You must enter a marketing headline title',
  },
  employment_type: {
    required: 'You must choose an employment type',
  },
  location: {
    required: 'You must enter a location',
  },
};

export const JOB_DETAIL_VALIDATE_FIELDS_FOR_VALID_CHARS = [
  'job_title',
  'salary',
  'job_url',
  'site_id',
];

export const OTHER_DETAILS_ERROR_MESSAGES = {
  displayTitle: {
    required: 'You must enter a display title',
  },
  body: {
    required: 'You must enter a body',
  },
};

export const ADMIN_VALIDATE_FIELDS_FOR_VALID_CHARS = [
  'min_expected_registrants',
  'max_expected_registrants',
  'facebook_daily_budget',
  'purchase_order',
  'salesforce_deal_contract_id',
  'salesforce_deal_line_item_id',
  'billing_reference_number',
  'external_vendor_id',
];

export const REGISTRANTS_DEFAULT_SORT_OPTIONS = {
  sort_field: 'createdAt',
  desc_sort: 'true',
};

export {
  TimeSlots,
  DEFAULT_CARD_HEIGHT,
  CARD_MARGIN_BOTTOM,
  HIRING_EVENTS_IMAGES_TYPES,
  CREATE_HIRING_EVENTS_STEPS,
  STATUS_COLORS,
  EVENT_STATUS_CONSTANTS,
  HIRING_EVENT_STATUS_LIST,
  REQUIRED_CARD_KEYS,
  REQUIRED_CARD_KEYS_REBRAND,
  SUBMIT_EVENT_PROMPT,
  DELETE_EVENT_PROMPT,
  CANCEL_EVENT_PROMPT,
  APPROVE_EVENT_PROMPT,
  DENY_EVENT_PROMPT,
  RE_SUBMIT_EVENT_PROMPT,
  DOWNLOAD_REGISTRATION_PROMPT,
  DOWNLOAD_REGISTRATION_PROMPT_REBRAND,
  EVENT_DETAIL_FIELD_REFS,
  ADMIN_DETAIL_FIELD_REFS,
  COVER_PHOTO_HEIGHT,
  COVER_PHOTO_WIDTH,
  LOGO_HEIGHT,
  LOGO_WIDTH,
  COVER_PHOTO_HEIGHT_REBRAND,
  COVER_PHOTO_WIDTH_REBRAND,
  LOGO_HEIGHT_REBRAND,
  LOGO_WIDTH_REBRAND,
  EVENT_JOB_DETAILS_INITIAL_STATE,
  EVENT_JOB_DETAILS_OPTIONAL_FIELDS,
  EVENT_JOB_DETAILS_INITIAL_ERRORS_STATE,
  EVENT_JOB_DETAILS_EMPLOYMENT_TYPES,
  EVENT_JOB_SALARY_REGEX,
  EVENT_OTHER_DETAILS_INITIAL_STATE,
  OTHER_DETAIL_HELP_TEXT,
  OTHER_DETAIL_HEADINGS,
  CARD_TITLES,
  EVENT_MORE_DETAILS_PILLS,
  EVENT_PROMPT_MODAL_INITIAL_STATE,
  EVENT_OTHER_DETAILS_INITIAL_STATE_REBRAND,
  SUCCESS_EVENT_PROMPT,
  SUCCESS_EVENT_PROMPT_REBRAND,
  EDIT_EVENT_PROMPT,
  EDIT_EVENT_PROMPT_REBRAND,
  DELETE_DETAIL_PROMPT,
  DELETE_DETAIL_PROMPT_REBRAND,
  TEXT_EDITOR_TABS,
  EVENT_TYPE,
  VALID_EVENT_TYPES,
  VALID_REGISTRANTS_EVENT_TYPES,
  TIME_ZONES_ABBRS,
  FACEBOOK_CHANNELS,
  VENDOR_NAMES,
  FACEBOOK_CHANNELS_VALUES,
  MARKETING_TITLE_LIMIT,
  EVENT_TYPE_CONSTANTS,
  EVENT_TYPES_WITH_VIRTUAL_EVENT_LINK,
  SORT_OPTIONS,
  SORT_OPTIONS_REBRAND,
  REGISTRANTS_SORT_OPTIONS,
  WARNING_BEFORE_EDIT_BODY_TEXT,
  WARNING_BEFORE_SAVE_BODY_TEXT,
  HIRING_EVENTS_STEPS_TITLE,
  HIRING_EVENTS_STEPS_TITLE_REBRAND,
  HIRING_EVENT_TABS,
  HIRING_EVENT_TABS_DESKTOP_TITLES,
  HIRING_EVENT_TABS_MOBILE_TITLES,
  INITIAL_EVENT_STATE,
  INITIAL_PROMOTION_DETAILS,
  INITIAL_ERROR_STATE,
  HIRING_EVENT_TABS_TITLES_REBRAND,
  EVENT_TAG_BG_COLOR_REBRAND,
  OPTIONAL_CARD_KEYS,
  EVENT_TYPE_TEXT,
  STATES,
  DEFAULT_SORT_OPTIONS,
  EVENT_TYPES_WITH_REGISTRATION_TAB,
};

export default {
  TimeSlots,
  DEFAULT_CARD_HEIGHT,
  CARD_MARGIN_BOTTOM,
  HIRING_EVENTS_IMAGES_TYPES,
  CREATE_HIRING_EVENTS_STEPS,
  STATUS_COLORS,
  EVENT_STATUS_CONSTANTS,
  HIRING_EVENT_STATUS_LIST,
  REQUIRED_CARD_KEYS,
  REQUIRED_CARD_KEYS_REBRAND,
  SUBMIT_EVENT_PROMPT,
  DELETE_EVENT_PROMPT,
  CANCEL_EVENT_PROMPT,
  APPROVE_EVENT_PROMPT,
  DENY_EVENT_PROMPT,
  RE_SUBMIT_EVENT_PROMPT,
  DOWNLOAD_REGISTRATION_PROMPT,
  DOWNLOAD_REGISTRATION_PROMPT_REBRAND,
  EVENT_DETAIL_FIELD_REFS,
  ADMIN_DETAIL_FIELD_REFS,
  COVER_PHOTO_HEIGHT,
  COVER_PHOTO_WIDTH,
  LOGO_HEIGHT,
  LOGO_WIDTH,
  COVER_PHOTO_HEIGHT_REBRAND,
  COVER_PHOTO_WIDTH_REBRAND,
  LOGO_HEIGHT_REBRAND,
  LOGO_WIDTH_REBRAND,
  EVENT_JOB_DETAILS_INITIAL_STATE,
  EVENT_JOB_DETAILS_OPTIONAL_FIELDS,
  EVENT_JOB_DETAILS_INITIAL_ERRORS_STATE,
  EVENT_JOB_DETAILS_EMPLOYMENT_TYPES,
  EVENT_JOB_SALARY_REGEX,
  EVENT_OTHER_DETAILS_INITIAL_STATE,
  EVENT_OTHER_DETAILS_INITIAL_STATE_REBRAND,
  OTHER_DETAIL_HELP_TEXT,
  OTHER_DETAIL_HEADINGS,
  CARD_TITLES,
  EVENT_MORE_DETAILS_PILLS,
  EVENT_PROMPT_MODAL_INITIAL_STATE,
  SUCCESS_EVENT_PROMPT,
  SUCCESS_EVENT_PROMPT_REBRAND,
  EDIT_EVENT_PROMPT,
  EDIT_EVENT_PROMPT_REBRAND,
  DELETE_DETAIL_PROMPT,
  TEXT_EDITOR_TABS,
  EVENT_TYPE,
  VALID_EVENT_TYPES,
  VALID_REGISTRANTS_EVENT_TYPES,
  TIME_ZONES_ABBRS,
  FACEBOOK_CHANNELS,
  VENDOR_NAMES,
  FACEBOOK_CHANNELS_VALUES,
  MARKETING_TITLE_LIMIT,
  EVENT_TYPE_CONSTANTS,
  EVENT_TYPES_WITH_VIRTUAL_EVENT_LINK,
  SORT_OPTIONS,
  SORT_OPTIONS_REBRAND,
  REGISTRANTS_SORT_OPTIONS,
  WARNING_BEFORE_EDIT_BODY_TEXT,
  WARNING_BEFORE_SAVE_BODY_TEXT,
  HIRING_EVENTS_STEPS_TITLE,
  HIRING_EVENTS_STEPS_TITLE_REBRAND,
  HIRING_EVENT_TABS,
  HIRING_EVENT_TABS_DESKTOP_TITLES,
  HIRING_EVENT_TABS_MOBILE_TITLES,
  INITIAL_EVENT_STATE,
  INITIAL_PROMOTION_DETAILS,
  INITIAL_ERROR_STATE,
  HIRING_EVENT_TABS_TITLES_REBRAND,
  EVENT_TAG_BG_COLOR_REBRAND,
  OPTIONAL_CARD_KEYS,
  EVENT_TYPE_TEXT,
  STATES,
  DEFAULT_SORT_OPTIONS,
  REGISTRANTS_DEFAULT_SORT_OPTIONS,
  EVENT_TYPES_WITH_REGISTRATION_TAB,
  EVENT_DETAIL_FIELDS_TO_VALIDATE_WITH_MARKDOWN_REGEX,
};
